module.exports = __webpack_public_path__ + "img/pink2.0b2517ab.png";